export const updateUserPreferences = async (preferences) => {
  try {
    // Example: Saving preferences to Firestore (adjust based on your storage method)
    const userId = preferences.userId; // Assume userId is part of preferences
    const db = firebase.firestore(); // Ensure Firebase is initialized in your project

    await db.collection('user_preferences').doc(userId).set(preferences, { merge: true });

    return { success: true };
  } catch (error) {
    console.error('Error saving user preferences:', error);
    throw error;
  }
};